module.exports = __webpack_public_path__ + "static/media/halifax.5b1afccc.png";